import script from "./GreenCheckIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./GreenCheckIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__